import { submitContentTrack } from '@/api/base'
import { getToken } from '@/utils/auth'

export const CONTENT_TRACK_MAP = {
  1: '立即激活',
  2: '借款',
  3: '立即激活额度',
  4: '绑卡申请',
  5: '绑卡确认',
  6: '开通权益',
  7: '弹窗理解激活',
  8: '放弃开通会员',
  9: '进入贷超列表',
  10: '点击贷超（名字）',
  11: '进入ocr识别',
  12: '进入基本信息填写',
  13: '提交基本信息成功',
  14: '提交人脸识别成功',
  15: '进入绑卡页面',

}

// 登录态内容埋点：未登录或参数不完整时直接跳过，不影响原业务流程。
export function trackContent(contentId, contentName) {
  const content = contentName || CONTENT_TRACK_MAP[contentId]
  if (!getToken() || !contentId || !content) {
    return Promise.resolve(false)
  }

  return submitContentTrack({ contentId, content })
    .then(() => true)
    .catch(() => false)
}
